export * from "./configuration.service";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-configuration-service/dist/index.js
// module id = 419
// module chunks = 1